//import { qs } from '../../../assets/js/src/scripts.js';
import { qs } from '../../../src/assets/js/src/scripts.js';

// Components shared with web and galaxo
import { default as stage } from './floor-map-stage.js';
import { default as reducer } from './floor-map-reducer.js';
import { default as businessShortinfo } from './floor-map-business-shortinfo.js';
import { default as router } from './floor-map-router.js';
import { default as trail } from './floor-map-trail.js';
import { default as footer } from './floor-map-footer.js';

// Components for Galaxo
//import { galaxoStats } from '../../../src/assets/js/src/scripts-galaxo.js';


/*

██ ███    ██ ██ ████████ ██  █████  ██      ██ ███████ ███████
██ ████   ██ ██    ██    ██ ██   ██ ██      ██    ███  ██
██ ██ ██  ██ ██    ██    ██ ███████ ██      ██   ███   █████
██ ██  ██ ██ ██    ██    ██ ██   ██ ██      ██  ███    ██
██ ██   ████ ██    ██    ██ ██   ██ ███████ ██ ███████ ███████

*/

document.addEventListener('contextmenu', event => event.preventDefault());


/*
** Prevent outbound links, code by ChatGPT
*/

/*
// Get the current domain
// Define an array of allowed domain names
var allowedDomains = ["kauppakeskusvalkea-v2.local",
											"kauppakeskusvalkea.fi",
											"#premise=",
											"#service=",
											"Kesakatu_kauppurienkatu_kesakatu"
										];

// Get all the links on the page
var allLinks = document.getElementsByTagName('a');

// Iterate through each link
for (var i = 0; i < allLinks.length; i++) {
  var link = allLinks[i];

  // Get the href attribute of the link
  var href = link.getAttribute('href');

  // Check if the link has an href attribute
  if (href) {
    // Check if the link has any matching parts with the allowed domains
    var isMatched = allowedDomains.some(function(domain) {
      return href.includes(domain);
    });

    // If there is no match, disable the link
    if (!isMatched) {
			console.log(href)

      link.addEventListener('click', function(event) {
        event.preventDefault();
      });

      // Optionally, you can add a visual indication that the link is disabled
      link.style.color = 'gray';
      link.style.textDecoration = 'none';
      // Or any other styling that suits your needs
    }
  }
}
*/


var $module;
var oldState = {};

function init(store) {

	var el = {};

	$module = el.$module = $('.floor-map--galaxo');

	if (!el.$module.length) {
		return;
	}

	el.$controls = el.$module.find('.btn-list');
	el.$floors = el.$module.find('.floor-map__floor');
	el.$stages = el.$floors.find('.floor-map__floor-stage');
	el.$maps = el.$stages.find('> svg');
	el.$businessShortinfos = el.$module.find('.business-shortinfo');

	store.dispatch({
		type: 'ADD_BUSINESS_DATA',
		businesses: window.valkeaFloorMapData.businesses,
	});

	businessShortinfo.init(el);
	trail.init(el, store);
	footer.init(el, store);
	stage.init(el, store, 'galaxo');
	router.init(el, store);

	registerGalaxoEvents(el, store);

	// Handle changes
	store.subscribe(() => {
		handleGalaxoChange(el, store);
	});

	// Ready
	window.setTimeout(function() {

		var params = window.location.search && window.location.search.replace('?', '');
		var hash = window.location.hash && window.location.hash.replace('#', '');
		var initialState = window.history.state || qs.parse(params || hash);

		if (initialState) {
			store.dispatch({
				type: 'LOAD_ROUTE',
				route: initialState
			});
		}

		window.setTimeout(function() {
			el.$module.addClass('is-ready');
		}, 500);

	}, 10);

}



/*

 ██████ ██   ██  █████  ███    ██  ██████  ███████ ███████
██      ██   ██ ██   ██ ████   ██ ██       ██      ██
██      ███████ ███████ ██ ██  ██ ██   ███ █████   ███████
██      ██   ██ ██   ██ ██  ██ ██ ██    ██ ██           ██
 ██████ ██   ██ ██   ██ ██   ████  ██████  ███████ ███████

*/



function handleGalaxoChange(el, store) {

	var state = store.getState();
	var selectionChanged = state.floorMap.selectionID !== oldState.selectionID;

	if (selectionChanged) {

		// Location changed
		if ([state.floorMap.selectionType, oldState.selectionType].includes('location')) {
			toggleLocation(state.floorMap.location && state.floorMap.location.name);
		}

	}

	oldState = Object.assign({}, state.floorMap);

}



/*

███████ ██    ██ ███████ ███    ██ ████████ ███████
██      ██    ██ ██      ████   ██    ██    ██
█████   ██    ██ █████   ██ ██  ██    ██    ███████
██       ██  ██  ██      ██  ██ ██    ██         ██
███████   ████   ███████ ██   ████    ██    ███████

*/




function registerGalaxoEvents(el, store) {

	// Back button
	el.$module.on('mousedown', '.floor-map__footer-back', function(e) {
		e.stopPropagation();
		store.dispatch({
			type: 'STEP_BACK'
		});
	});

	// Business shortinfo link handler
	$('.business-shortinfo-container').on('mousedown', 'a', function(e) {
		e.stopPropagation();
		setTimeout(() => { document.location.href = this.href; }, 150);
	});

	// Stats: floor
	/*
	el.$module.find('.Kerros, .floor-map__floor-number').on('mousedown', function(e) {
		var floorID = $(this).closest('.floor-map__floor').data('floor') || $(this).data('floor');
		if (oldState.step !== 2 && oldState.step !== 3) {
			galaxoStats.send('map_floor', floorID);
		}
	});
	*/

	// Stats: business
	/*
	el.$stages.on('mousedown', '.premise, .floor-map__nametag', function(e) {

		var premiseID = $(this).data('premise');
		var businessShortinfo = oldState.businesses.find(business => business.premise.includes(premiseID));

		if (businessShortinfo && !this.matches('.disabled')) {
			galaxoStats.send('map_business', businessShortinfo.title);
		}
	});
	*/

}



/*

██████  ███████ ███    ██ ██████  ███████ ██████      ██████   ██████  ███    ███
██   ██ ██      ████   ██ ██   ██ ██      ██   ██     ██   ██ ██    ██ ████  ████
██████  █████   ██ ██  ██ ██   ██ █████   ██████      ██   ██ ██    ██ ██ ████ ██
██   ██ ██      ██  ██ ██ ██   ██ ██      ██   ██     ██   ██ ██    ██ ██  ██  ██
██   ██ ███████ ██   ████ ██████  ███████ ██   ██     ██████   ██████  ██      ██

*/



/*
 * Show "My location"
 */
function toggleLocation(location) {

	$module.removeClass('has-selected-location');
	$module.find('.Lokaatio').children().removeClass('is-active');

	if (location) {
		$module.find(`.${location}`).addClass('is-active');
		$module.addClass('has-selected-location');
	}

}





/**
 * Module exports
 */

export default {
	init,
	reducer
};
